import { useQuery } from '@tanstack/react-query';
import type { AgentApiCsvMappingTemplatesIndex } from '@/types/serializers';

export default function useFetchCsvMappingTemplates() {
  return useQuery({
    queryKey: ['csvMappingTemplates'],
    queryFn: async () => {
      const response = await fetch('/agent/api/csv_mapping_templates');
      if (!response.ok) {
        throw new Error('CSVマッピングテンプレート一覧の取得に失敗しました');
      }
      const data: AgentApiCsvMappingTemplatesIndex = await response.json();
      return data;
    },
  });
}
